export var ValidUsernameResponseType;
(function (ValidUsernameResponseType) {
    ValidUsernameResponseType["NOT_IN_USE"] = "NOT_IN_USE";
    ValidUsernameResponseType["ALREADY_IN_USE"] = "ALREADY_IN_USE";
    ValidUsernameResponseType["IN_VALID_FORMAT"] = "IN_VALID_FORMAT";
})(ValidUsernameResponseType || (ValidUsernameResponseType = {}));
